import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";

import { setup, status } from "../api/auth.ts";

export default function SetupPage() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["auth", "status"], queryFn: status });
  const [form, setForm] = useState({
    account_name: "WebSquad Ops",
    account_slug: "websquad",
    admin_email: "",
    admin_full_name: "",
    password: "",
    confirm_password: "",
  });
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (isLoading) return <div className="p-8 text-sm text-slate-500">…</div>;
  if (data && !data.setup_required) return <Navigate to="/login" replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await setup(form);
      nav("/dashboard", { replace: true });
    } catch (err) {
      setError(String((err as Error).message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center p-6">
      <form onSubmit={submit} className="card w-full max-w-md space-y-4">
        <h1 className="text-2xl font-semibold">{t("auth.setup.title")}</h1>
        <label className="block text-sm">
          <span className="mb-1 block font-medium">Account name</span>
          <input className="input" value={form.account_name} onChange={(e) => setForm({ ...form, account_name: e.target.value })} required />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block font-medium">Account slug</span>
          <input className="input" value={form.account_slug} onChange={(e) => setForm({ ...form, account_slug: e.target.value })} pattern="[a-z0-9-]+" required />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block font-medium">Admin email</span>
          <input type="email" className="input" value={form.admin_email} onChange={(e) => setForm({ ...form, admin_email: e.target.value })} required />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block font-medium">Admin full name</span>
          <input className="input" value={form.admin_full_name} onChange={(e) => setForm({ ...form, admin_full_name: e.target.value })} required />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block font-medium">Password</span>
          <input type="password" className="input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} minLength={12} required />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block font-medium">Confirm password</span>
          <input type="password" className="input" value={form.confirm_password} onChange={(e) => setForm({ ...form, confirm_password: e.target.value })} minLength={12} required />
        </label>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button type="submit" className="btn w-full" disabled={submitting}>
          {t("auth.setup.submit")}
        </button>
      </form>
    </div>
  );
}
